import styled from 'styled-components';

export const StarWrapper = styled.span`
  color: #ffcd51;
  flex-shrink: 0;
  font-size: 1rem;
`;
